<div class="color-blue">
  {{ 'screening.screening_overrides.export.company_information.company_roles.title' | translate }}
</div>
<div>
  @if (company$ | async; as company) {
    {{
      'screening.screening_overrides.export.company_information.company_roles.description'
        | translate: { companyName: company.name | prettyCompanyName }
    }}
  }
</div>
<br />
@if (personCompanyRolePersonFlagCompositeEntities$ | async; as items) {
  <table>
    <tbody>
      @for (item of items; track item.companyRole.company_role_rank) {
        <tr>
          <td class="width-50">
            <b>{{ 'company_role.' + item.companyRole.company_role_key | translate }}</b>
          </td>
          <td>
            @for (entity of item.entities; track entity.person.person_master_uuid) {
              <div>
                <nk-person-title [person]="entity.person"></nk-person-title>
              </div>
            }
          </td>
        </tr>
        <br />
      }
    </tbody>
  </table>
}
